import { MoreVertical, Download, Tag, Trash2 } from "lucide-react";
import type { DocumentId } from "@/packages/types";
import { Dropdown } from "@/components/ui";
import { useTranslation } from "@audit-app/utils";

interface DocumentRowMenuProps {
  documentId: DocumentId;
  documentTitle: string;
  onDownload: () => void;
  onDelete: () => void;
  onEditTags: () => void;
}

export function DocumentRowMenu({
  onDownload,
  onDelete,
  onEditTags,
}: DocumentRowMenuProps) {
  const { t } = useTranslation(["documents"]);
  return (
    <Dropdown>
      <Dropdown.Trigger>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className="flex items-center justify-center w-11 h-11 rounded-lg hover:bg-card-hover transition-colors"
          aria-label={t("actions.documentActions")}
        >
          <MoreVertical size={20} className="text-secondary" />
        </button>
      </Dropdown.Trigger>

      <Dropdown.Content align="end" side="bottom">
        <Dropdown.Item onSelect={onDownload} icon={<Download size={16} />}>
          {t("documents:documentRowMenu.download")}
        </Dropdown.Item>

        <Dropdown.Item onSelect={onEditTags} icon={<Tag size={16} />}>
          {t("documents:documentRowMenu.editTags")}
        </Dropdown.Item>

        <Dropdown.Item
          onSelect={onDelete}
          destructive
          icon={<Trash2 size={16} />}
        >
          {t("documents:documentRowMenu.delete")}
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown>
  );
}
